'use client'

import dynamic from 'next/dynamic'

const CheckMark = dynamic(() => import('./tooltip').then(mod => mod.TooltipComponent), {
  ssr: false,
})

type CheckProps = React.HTMLAttributes<HTMLDivElement> & {
  isNotFoundPage?: boolean
}

export function CheckMarkClient({ className, isNotFoundPage, ...rest }: CheckProps) {
  return <CheckMark className={className} isNotFoundPage={isNotFoundPage} {...rest} />
}
